import querystring from "query-string";
import { formatISODate } from "Tools";

export enum CaseStatusFilter {
  Open = "Open",
  Closed = "Closed",
  All = "All",
}

export enum ClaimStatusFilter {
  UnderReview = "UnderReview",
  Paid = "Paid",
  Denied = "Denied",
  HasClaim = "HasClaim",
  NoClaim = "NoClaim",
  All = "All",
}

export function getDownloadAdminReportUrl(
  startDate: Date,
  lastDate: Date,
  caseStatusFilter: CaseStatusFilter,
  claimStatusFilter: ClaimStatusFilter,
) {
  return `/DownloadAdminReport?${querystring.stringify({
    startDate: formatISODate(startDate),
    lastDate: formatISODate(lastDate),
    caseStatusFilter,
    claimStatusFilter,
  })}`;
}

export function getDownloadAspenBordereauUrl(startDate: Date, lastDate: Date) {
  return `/DownloadAspenReport?${querystring.stringify({
    startDate: formatISODate(startDate),
    lastDate: formatISODate(lastDate),
  })}`;
}

export function getDownloadPolicyholderSummaryUrl(
  startDate: Date,
  lastDate: Date,
  caseStatusFilter: CaseStatusFilter,
  claimStatusFilter: ClaimStatusFilter,
) {
  return `/DownloadPolicyholderSummary?${querystring.stringify({
    startDate: formatISODate(startDate),
    lastDate: formatISODate(lastDate),
    caseStatusFilter,
    claimStatusFilter,
  })}`;
}

export function getDownloadUnpurchasedAppsReportUrl(
  startDate: Date,
  lastDate: Date,
) {
  return `/DownloadUnpurchasedAppsReport?${querystring.stringify({
    startDate: formatISODate(startDate),
    lastDate: formatISODate(lastDate),
  })}`;
}

export function getDownloadPartnerReportUrl(
  partnerId: number,
  startDate: Date,
  lastDate: Date,
) {
  return `/DownloadPartnerReport?${querystring.stringify({
    partnerId,
    startDate: formatISODate(startDate),
    lastDate: formatISODate(lastDate),
  })}`;
}

interface AppForDocumentUrls {
  securityKey: string;
  applicant: {
    state: string;
  };
}

export function getDownloadPolicyDocumentUrl(app: AppForDocumentUrls) {
  return `/${app.applicant.state}/DownloadPolicy/${app.securityKey}`;
}

export function getFeeCoverageDocumentUrl(app: AppForDocumentUrls) {
  return `/${app.applicant.state}/DownloadFeeCoverageDocument/${app.securityKey}`;
}

export function getDownloadComplaintDocumentUrl(app: AppForDocumentUrls) {
  return `/${app.applicant.state}/DownloadComplaintDocument/${app.securityKey}`;
}

export function getDownloadSurplusLinesDocumentUrl(app: AppForDocumentUrls) {
  return `/${app.applicant.state}/DownloadSurplusLinesDisclosure/${app.securityKey}`;
}

export function getDownloadApplicationAnswersUrl(app: AppForDocumentUrls) {
  return `/${app.applicant.state}/DownloadApplicationAnswers/${app.securityKey}`;
}

export function getDownloadLossPayeeEndorsementUrl(app: AppForDocumentUrls) {
  return `/${app.applicant.state}/DownloadLossPayee/${app.securityKey}`;
}

export function getDiligentEffortFormUrl(app: AppForDocumentUrls) {
  return `/${app.applicant.state}/DownloadDiligentEffortForm/${app.securityKey}`;
}
